import React from "react";
import type { IconProps } from "./types";

/**
 * TextFormatNumericIcon component that renders a text format numeric icon SVG
 * @param props - The component props
 * @param props.className - CSS class name for styling
 * @param props.width - Width of the icon (default: 16)
 * @param props.height - Height of the icon (default: 16)
 * @returns The rendered text format numeric icon component
 */
const TextFormatNumericIcon: React.FC<IconProps> = ({ className, width = 16, height = 16 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M2.44 5.17V9.86" />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        d="M0.78 6.42h0.42c0.69 0 1.25 -0.56 1.25 -1.25v0"
      />
      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M4.11 10.16H0.78" />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        d="M11.3 9.33c0.17 0.48 0.63 0.83 1.18 0.83h0.83c0.69 0 1.25 -0.56 1.25 -1.25v-0.21c0 -0.69 -0.56 -1.25 -1.25 -1.25h-0.42h0.31c0.63 0 1.14 -0.51 1.14 -1.14c0 -0.63 -0.51 -1.14 -1.14 -1.14h-0.62c-0.52 0 -0.96 0.35 -1.1 0.83"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
        d="M9.37 10.16H6.04v-0.71c0 -0.5 0.29 -0.94 0.75 -1.14l1.85 -0.81c0.44 -0.19 0.73 -0.63 0.73 -1.11c0 -0.67 -0.54 -1.22 -1.22 -1.22H7.28c-0.54 0 -1.01 0.35 -1.18 0.83"
      />
    </svg>
  );
};

export default TextFormatNumericIcon;
